module.exports = __webpack_public_path__ + "img/home-07-cosmo-01-popup-03.635ab90b.jpg";